module.exports = __webpack_public_path__ + "static/img/trends2.64fccd4c.webp";